<template>
  <div class="busqueda_general_list" v-show="show_this">
    <a class="badge badge-primary" v-if="showBtnAnalytics" :href="analyticsUrl">
      <i class="fas fa-chart-bar">ANALYTICS</i>
    </a>
    <user-subscription-modal-login-vue ref="user_subscription_login_modal" @login:success="save_document"/>
    <label class="busqueda_general_label" ><a id='search_btn' :href="advancedSearchUrl" >{{ label }}</a> <span class="num_found badge pull_right">{{ numFound }}</span></label>
    <documents-item-vue
      v-for='(document, index) in documents'
      v-bind='document'
      v-bind:key='document.id'
      v-bind:index='index'
      v-bind:search_type='search_type'
      v-bind:token_id='token_id'
      @save:document="save_document"
      v-bind:hide_save_document='hide_save_document'
      v-bind:route='route'
      v-bind:hide_quick_view='hide_quick_view'
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import mixins from 'common/mixins'
import token_formatter from 'common/token_formatter.js'

export default {
  name: 'search-general-list',
  props: {
    name: { type: String, default: '' },
    hide_save_document: { type: Boolean, default: false },
    route: { type: String, default: null },
    hide_quick_view: { type: Boolean, default: false }
  },
  data() {
    return {
      loginSuccessAction: {},
    }
  },
  components: {
    'documents-item-vue': () => import(/* webpackChunkName: "[request]" */ "components/documents/Item"),
    'user-subscription-modal-login-vue': () =>import( /* webpackChunkName: "[request]" */ "components/user_subscription/ModalLogin")
  },
  mixins: [mixins.requests, mixins.translate],
  computed: {
    show_this() {
      return !!this.numFound && (this.numFound > 0)
    },
    cleaned_tokens() {
      return token_formatter.format_and_split_tokens(this.searchTokens)
    },
    searchAttributes() {
      return { ...this.searchGroups.find((group) => group.name == this.name) }
    },
    numFound() {
      return this.groupResults[this.name] ? this.groupResults[this.name].total : 0
    },
    documents() {
      return this.groupResults[this.name] ? this.groupResults[this.name].result : []
    },
    token() {
      return this.groupResults[this.name] ? this.groupResults[this.name].token : {}
    },
    advancedSearchUrl() {
      let url = ''
      url = `${gon.url_for.searches.replace(
        ':search_type',
        this.searchAttributes.search_type
      )}?token_id=${this.token.id}`
      return url
    },
    showBtnAnalytics(){
      return this.isJurisprudencia && gon.current_app_has_analytics
    },
    analyticsUrl(){
      return this.url_for_analytics(this.token.id)
    },
    label() {
      return this.t(`search.forms.${this.name.replace('_', '.')}.label`)
    },
    isJurisprudencia() {
      return this.name == 'jurisprudencia' || this.name == 'jurisprudencia_jurisprudencia'
    },
    ...mapState('search', [
      'tokenId',
      'searchTokens',
      'searchGroups',
      'groupResults'
    ]),
    ...mapGetters(["has_user_subscription"])
  },
  methods: {
    save_document(params = {}){
      if(this.has_user_subscription){
        this.http_get({
          url: this.url_for_user_subscriptions_document_new({...params,...this.loginSuccessAction.attr}),
          format: "JS"
        })
      }else {
        this.loginSuccessAction = {name: 'save_document', 'attr': params}
        this.showLoginForm()
      }
    },

    showLoginForm() {
      this.$refs.user_subscription_login_modal[0].show()
    }
  }
}
</script>
